import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { memo, useMemo, useRef } from 'react';
import { jsx } from '@emotion/core';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { itemStyles, itemWrapperStyles } from '../internal/styles';
import Step from './internal/step';
import useOverflowable from './internal/use-overflowable';
const AKTooltip = lazyForPaint(() => import(
/* webpackChunkName: "@atlaskit-internal_Tooltip" */
'@atlaskit/tooltip'), {
  ssr: false
});
const BreadcrumbsItem = /*#__PURE__*/memo(props => {
  const buttonRef = useRef(null);
  const {
    truncationWidth,
    text,
    ...restButtonProps
  } = props;
  const showTooltip = useOverflowable(truncationWidth, buttonRef);
  const buttonProps = { ...restButtonProps,
    ref: buttonRef,
    hasOverflow: showTooltip
  };
  const styles = useMemo(() => itemStyles(truncationWidth), [truncationWidth]);
  const step = jsx(Step, _extends({}, buttonProps, {
    css: styles
  }), text);
  return jsx("li", {
    css: itemWrapperStyles
  }, showTooltip ?
  /* The div exists because of tooltip */
  jsx(LazySuspense, {
    fallback: jsx("div", null, step)
  }, jsx(AKTooltip, {
    content: text,
    position: "bottom"
  }, step)) : step);
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default BreadcrumbsItem;